import FeedVirtualized from '../../components2/Feed/FeedVirtualized';

import {
    fetchHomeFeedRecent,
    HOME_FEED_MEDIAS_KEY
} from "../../../api/public-voissa/home-feed";
import { useInfiniteQuery } from '@tanstack/react-query';
import { FilterButtonDropdown } from '../../components2/FilterButton/FilterButton';
import { config } from '../../../config';
import { useFiltersStorage } from '../../../hooks/useFiltersStorage';

const HomeFeedMostRecent = ()=>{
    const {getFilter, setFilter} = useFiltersStorage();
    const genderFilter = getFilter('gender', []);
    const infiniteQuery = useInfiniteQuery(
        [HOME_FEED_MEDIAS_KEY, genderFilter],
        ({pageParam = 1}) => fetchHomeFeedRecent({page : pageParam, gender: genderFilter.map((gender)=>config.genderList.indexOf(gender))}),
        {
            staleTime : (60 * 60 * 1),
            getNextPageParam: (lastPage) => {
                const nextPage = lastPage && lastPage.more ? lastPage.page + 1 : null;
                return nextPage;
            }
        }
    );

    const handleGenderFilter = (selectedGender)=>{
        if(!selectedGender) setFilter('gender',[]);
        else if(!genderFilter.includes(selectedGender)) setFilter('gender',[...genderFilter, selectedGender]);
        else setFilter('gender',genderFilter.filter(gender=>gender!==selectedGender));
    }

    const filterOptions = [
        {
            label : (active)=> (<>{active && "• "}Tous les genres</>),
            active : !genderFilter.length,
            default: true,
            data : null
        },
        ...config.genderList.map(gender=>({
            label : (active)=> (<>{active && "• "} {gender}</>),
            active : genderFilter.includes(gender),
            data : gender
        })).filter((fOption, i)=>!!i)
    ];

    return (
        <>
            <div style={{display:'flex', justifyContent:'flex-end'}}>
                <FilterButtonDropdown options={filterOptions} label="Genre" onSelect={handleGenderFilter}/>
            </div>
            <FeedVirtualized
                infiniteQuery={infiniteQuery}
            />
        </>
    )
}

export default HomeFeedMostRecent;